import { FC, useEffect, useState } from "react";
import { ControlType, IEntity, Property, PropertyType } from "../../../base/types";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { MUIIcon, Spinner } from "../../../widgets";
import { DownloadLinkCell } from "../downloadable-document";
import { useGetHallTicketDetails } from "./properties/useGetHallTicketdetails";
import { useGetProperties } from "../../../base/hooks";
import { IFieldValue } from "../../../services/models";
import { useUpdateMutation } from "../../../services/data/tableDataApi";
import { useAuth } from "../../../../modules/auth";
import { useGetAcademicSessionName } from "./properties/useGetAcademicSessionName";

export const HallTicketComponent: FC<IControlAttributes> = ({
    control,
    className,
    ...rest
}) => {
    const { hallTickets, isLoading } = useGetHallTicketDetails();
    const { properties } = useGetProperties({ bindings: control.bindings });
    const iconName: string | undefined = properties[Property.MaterialIcon];
    const { user, siteId } = useAuth();
    const [updateRecord] = useUpdateMutation();
    const [loading, setLoading] = useState(false);
    const { getAcademicPeriodName, isLoading: isAcademicLoading } = useGetAcademicSessionName();
    const hallTicket = hallTickets && hallTickets.length > 0 ? hallTickets[0] : null;

    if (isLoading || isAcademicLoading) {
        return <Spinner show={true} />;
    }
    const handleUpdateHallTicket = () => {
        const currentDateTime = new Date().toISOString();
        const record: IEntity = {
            edtec365_generateddate: currentDateTime,
        };

        setLoading(true);
        saveFormData(record)
            .catch(err => {
                const message = err.data?.message || "An error occurred while processing your request. Please try again later.";
                console.error(message);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const saveFormData = (record: IEntity): Promise<IEntity> => {
        const fields: IFieldValue[] = Object.entries(record)
            .filter(([_, value]) => value !== undefined)
            .map(([field, value]) => ({ field, value, validate: true }));

        return updateRecord({
            portalId: siteId || "",
            userId: user?.contactId,
            tableId: "slcm_hallticket",
            sysId: hallTicket?.slcm_hallticketid || "",
            data: fields,
            triggers: true,
        })
            .unwrap()
            .catch(err => {
                const message = err.data?.message || "An error occurred while processing your request. Please try again later.";
                console.error(message);
                return Promise.reject(message);
            });
    };

    if (!hallTicket) {
        return (
            <div className="container bg-white rounded p-4 text-center">
                {/* <p>Hall ticket Not generated yet</p> */}
            </div>
        );
    }

    return (
        <div className="container bg-secondary rounded p-4 shadow-sm">
            <h3 className="mb-4">Download Your TLFQ COMPLETION CERTIFICATE</h3>
            <div className="row border rounded p-3">
                <div className="col-md-9 col-8">
                    <div className="d-flex flex-column gap-2">
                        <div className="row">
                            <div className="col-md-3">
                                <strong>Exam Name:</strong>
                            </div>
                            <div className="col-md-9">
                                <span>{hallTicket.slcm_examname}</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <strong>Academic Session:</strong>
                            </div>
                            <div className="col-md-9">
                                <span>
                                    {getAcademicPeriodName(hallTicket.slcm_academicperiod)}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-4 d-flex justify-content-end align-items-center">
                    {hallTicket?.slcm_hallticket && (
                        <div
                            className="btn btn-primary btn-sm d-flex align-items-center justify-content-center px-2 py-1"
                            style={{
                                height: "32px",
                                lineHeight: "1",
                                borderRadius: "6px",
                                whiteSpace: "nowrap",
                            }}
                            onClick={handleUpdateHallTicket}
                        >
                            {loading && <Spinner className="me-2" show={loading} />}
                            {iconName && <MUIIcon iconName={iconName} className="me-2" />}
                            <DownloadLinkCell
                                fieldUrl={hallTicket.slcm_hallticket}
                                label="Download"
                                target="new tab"
                                className="text-white text-decoration-none small"
                                enableDownload={true}
                            />
                        </div>

                    )}
                </div>
            </div>
        </div>
    );
};

Registry.addControl({
    id: "4a5749b4-7aeb-4a3d-9cb5-5b318e58281d",
    name: "Hall Ticket Component",
    type: ControlType.HallTicketComponent,
    properties: [
        { id: Property.Tooltip, name: "Tooltip", type: PropertyType.String },
        { id: Property.MaterialIcon, name: 'Icon', type: PropertyType.MaterialIcon },
    ],
    component: HallTicketComponent,
});